export const FETCH_USER = 'fetch_user';
export const HYDRATE_AUTH = 'hydrate_auth';
export const SET_LOADING = 'set_loading';
export const CLEAR_AUTH = 'clear_auth';